/**************************************************
 * Nombre:       Formulario_Fotos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, PetsOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPRODUCTO} from "../../Constantes";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";

const Formulario_Fotos = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagen dato={'img'} {...props}  />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>Peso Maximo 500k</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSPRODUCTO.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={PetsOutlined} nombre={'Nombre'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Fotos